/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "aa8ee061fee04eba56d235b2acbde7bf938aff6c";
